export const WS_CLOSE_AUTH_REJECTED = 4401;

export function createWebSocket({ wsBaseUrl, onOpen, onMessage, onError, onClose }) {
  const ws = new window.WebSocket(wsBaseUrl);

  ws.onopen = () => {
    if (onOpen) onOpen();
  };
  ws.onmessage = (event) => {
    if (onMessage) onMessage(event);
  };
  ws.onerror = (error) => {
    if (onError) onError(error);
  };
  ws.onclose = (event) => {
    if (onClose) onClose(event);
  };
  return ws;
}
